import { render, staticRenderFns } from "./BackstageSlideButtons.vue?vue&type=template&id=cdcc7632&scoped=true&"
import script from "./BackstageSlideButtons.vue?vue&type=script&lang=js&"
export * from "./BackstageSlideButtons.vue?vue&type=script&lang=js&"
import style0 from "./BackstageSlideButtons.vue?vue&type=style&index=0&id=cdcc7632&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdcc7632",
  null
  
)

export default component.exports